import SeoHead from "@/components/public/SeoHead";
import Breadcrumb from "@/components/public/Breadcrumb";

export default function PolitiqueCookiesPage() {
  return (
    <div data-testid="politique-cookies-page">
      <SeoHead title="Politique de cookies" description="Politique de cookies du site nettoyage-expert.ch. Informations sur l'utilisation des cookies et vos droits." path="/politique-cookies" noindex={true} />
      <Breadcrumb items={[{ name: "Accueil", url: "/" }, { name: "Politique de cookies" }]} />
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate max-w-none">
          <h1 className="text-3xl sm:text-4xl font-semibold text-[#062133] tracking-tight mb-8" data-testid="cookies-h1">Politique de cookies</h1>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Éditeur du site</h2>
          <p className="text-[#062133]/70 leading-relaxed">
            <strong>HOMELY SOLUTIONS Sàrl</strong> — Rue Jean-André-Venel 4, 1400 Yverdon-les-Bains, Suisse<br />
            IDE : CHE-418.697.448 — N° TVA : CHE-418.697.448 TVA
          </p>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Qu'est-ce qu'un cookie ?</h2>
          <p className="text-[#062133]/70 leading-relaxed">
            Un cookie est un petit fichier texte déposé sur votre appareil (ordinateur, tablette, smartphone) lors de la visite d'un site web. Il permet au site de mémoriser des informations sur votre visite, comme votre langue préférée ou d'autres paramètres, afin de faciliter votre prochaine visite et de rendre le site plus utile.
          </p>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Cookies utilisés sur ce site</h2>

          <h3 className="text-lg font-medium text-[#062133] mt-6 mb-3">Cookies strictement nécessaires</h3>
          <p className="text-[#062133]/70 leading-relaxed">
            Ces cookies sont essentiels au fonctionnement du site. Ils permettent l'utilisation des principales fonctionnalités (navigation, formulaires). Sans ces cookies, le site ne peut pas fonctionner correctement. Ils ne nécessitent pas votre consentement.
          </p>

          <h3 className="text-lg font-medium text-[#062133] mt-6 mb-3">Cookies de performance et d'analyse</h3>
          <p className="text-[#062133]/70 leading-relaxed">
            Actuellement, ce site n'utilise <strong>aucun cookie de tracking ou d'analyse</strong> (pas de Google Analytics, pas de pixel Facebook, pas de cookie publicitaire). Si nous devions en intégrer à l'avenir, cette page serait mise à jour et votre consentement serait demandé préalablement.
          </p>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Gestion des cookies</h2>
          <p className="text-[#062133]/70 leading-relaxed">
            Vous pouvez à tout moment configurer votre navigateur pour accepter ou refuser les cookies. Voici les liens vers les pages de gestion des cookies des principaux navigateurs :
          </p>
          <ul className="text-[#062133]/70 space-y-2 mt-3">
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#336DBF]">Google Chrome</a></li>
            <li><a href="https://support.mozilla.org/fr/kb/protection-renforcee-contre-pistage-firefox-ordinateur" target="_blank" rel="noopener noreferrer" className="text-[#336DBF]">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/fr-ch/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#336DBF]">Safari</a></li>
            <li><a href="https://support.microsoft.com/fr-fr/microsoft-edge/supprimer-les-cookies-dans-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-[#336DBF]">Microsoft Edge</a></li>
          </ul>

          <h2 className="text-xl font-semibold text-[#062133] mt-10 mb-4">Contact</h2>
          <p className="text-[#062133]/70 leading-relaxed">
            Pour toute question relative à notre politique de cookies, contactez-nous à <a href="mailto:info@nettoyage-expert.ch" className="text-[#336DBF]">info@nettoyage-expert.ch</a>.
          </p>

          <p className="text-[#062133]/40 text-xs mt-12">Dernière mise à jour : septembre 2026</p>
        </div>
      </section>
    </div>
  );
}
